import { combineReducers } from 'redux';
import auth from './auth/reducer';
import api from './api/reducer'
import theme from './theme/reducer'
import base from './base/reducer'
import leads from './leads/reducer'
import leadsSyc from './leads-syc/reducer'
import leadsCrm from './leads-crm/reducer'
import reports from './reports/reducer'

const reducers = combineReducers({
  api,
  auth,
  theme,
  base,
  leads,
  leadsSyc,
  leadsCrm,
  reports
});

export default reducers;